import { Link, useNavigate, useParams } from 'react-router';
import { contactKeys, useContact } from '../../queries/ContactQueries';
import AppLayout from '../../components/AppLayout';
import { FaEdit } from 'react-icons/fa';
import { formatPhoneNumbers } from '../../helpers/formatters';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import ContactApi from '../../apis/contact_api';
import { useQueryClient } from '@tanstack/react-query';
import { handleError } from '../../apis';
import { toast } from 'react-toastify';

export default function ContactPage() {
  const params = useParams();
  const contactId = params?.id ? +params.id : 0;
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { data: contact, isError, isPending, error } = useContact(contactId);

  const handleDelete = async () => {
    const proceed = window.confirm(
      'Deleting a contact can not be undone. Are you sure?',
    );
    if (!proceed) return;
    try {
      await ContactApi.deleteContact(contactId);
      queryClient.removeQueries({ queryKey: contactKeys.detail(contactId) });
      queryClient.invalidateQueries({ queryKey: contactKeys.all });
      navigate('/contacts');
    } catch (error) {
      const message = handleError(error);
      toast.error(message);
    }
  };
  return (
    <AppLayout>
      <ShowPending isPending={isPending} />
      <ShowError error={error} isError={isError} />
      <div className='w-full'>
        <div className='flex items-start justify-center'>
          <h3 className='text-center text-2xl dark:text-gray-300'>
            {contact?.name ?? ''}
          </h3>
          <Link
            to={`/update-contact/${contact?.contactId}`}
            className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
          >
            <div className='flex items-center gap-2'>
              <FaEdit /> Edit
            </div>
          </Link>
        </div>
        <div
          className={`mb-2 flex justify-center text-xs font-bold uppercase ${
            contact?.active ? '' : 'text-amber-500 dark:text-amber-200'
          }`}
        >
          {contact?.active ? 'Active' : 'Archived'}
        </div>

        <p className='text-center font-bold'>
          {contact && contact?.contactRole?.contactRoleName}
        </p>
        <div className='flex items-center justify-center gap-8 max-[640px]:flex-col max-[640px]:items-start max-[640px]:ps-4'>
          <div>
            {contact?.address1 && <p>{contact.address1}</p>}
            {contact?.address2 && <p>{contact.address2}</p>}
            {contact?.city && (
              <p>
                {contact.city}, {contact.state?.abbreviation}{' '}
                {contact.zipcode}{' '}
              </p>
            )}
          </div>
          <div>
            {contact?.phoneNumber && (
              <p>{formatPhoneNumbers(contact.phoneNumber)}</p>
            )}
            {contact?.email && <p>{contact.email}</p>}
          </div>
        </div>

        {/* <div className="pt-4">
        <h4>Events</h4>
      </div> */}

        <div className='flex justify-end p-4'>
          <button
            className='my-2  rounded-md border border-rose-600 bg-rose-500 p-2 text-xs font-bold uppercase text-white hover:border-rose-700 hover:bg-rose-600 dark:border-rose-500 dark:bg-rose-500  dark:hover:border-rose-600  dark:hover:bg-rose-600 '
            type='submit'
            title={`Delete ${contact?.name ?? 'Contact'}`}
            onClick={handleDelete}
          >
            Delete Contact
          </button>
        </div>
      </div>
    </AppLayout>
  );
}
